import Title from "../../../commons/Title";
import classes from "./index.module.scss";

export default function Technologies() {
  return (
    <section className={classes.section}>
      <div className={classes.container}>
        <div className={classes.body}>
          <div className={classes.content}>
            <Title
              title="Technologies Introduced"
              number={"04"}
              className={classes.title}
            />
          </div>
          <ul className={classes.list}>
            <li className={classes.item}>
              <h3>Node.js, React Native, Swift, Solidity </h3>
              <p>
                A high level of expertise in mentioned languages leads to
                iterated and planned technical goal reach;
              </p>
            </li>
            <li className={classes.item}>
              <h3>iOS</h3>
              <p>
                In order to cover the most-paid audience and provide the best
                native experience, we have focused on iOS with further
                distribution in the App Store.
              </p>
            </li>
            <li className={classes.item}>
              <h3>Geo-Location</h3>
              <p>
                Integration of Google services for locating helped to cover
                tasks and the most optimal routing for delivery and user
                positioning.
              </p>
            </li>
            <li className={classes.item}>
              <h3>AR</h3>
              <p>
                We provided a unique solution to work with content in an
                entirely different manner than competitors could.
              </p>
            </li>
            <li className={classes.item}>
              <h3>Firebase</h3>
              <p>
                Reach package of tools solved multiple problems such as
                authentication, notifications, crash reports, remote
                configurations, etc. in the safest fashion.
              </p>
            </li>
            <li className={classes.item}>
              <h3>AWS</h3>
              <p>
                Managing the server was simple and clear using the AWS control
                panel so customers could see loads at a specific moment in time.
              </p>
            </li>
            <li className={classes.item}>
              <h3>NFT unique drops</h3>
              <p>
                A unit of data stored on a digital ledger, called a blockchain,
                that certifies a digital asset to be unique and therefore not
                interchangeable.
              </p>
            </li>
            <li className={classes.item}>
              <h3>Amplitude</h3>
              <p>
                The behavior of our users, conversation, and funnels was
                gathered in the dashboard creation. Generalized information
                became easy to understand. On the other hand, it provided a
                significant basis for deep analysis and user-splitting into
                audiences with further ability to hypothesize and check
                causations and correlations.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
